<template>
  <div class="bgManageTopbar">
    <div class="topbarContent">
      <div class="leftIconDiv">
        <div class="flex" @click="goHome">
          <div class="flex">
          <img src="@/assets/goHomeIcon.png" alt="" class="goHomeIcon" />
        </div>
        <div class="goHomeText">官网首页</div>
        </div>
 
        <div class="goRegister" v-if="isRegister" @click="goLogin">
          <div class="flex">
          <img src="@/assets/goLogin.png" alt="" class="goLogin" />
        </div>
        <div class="goHomeText">去登录</div>
        </div>
      </div>
      <div class="titleText">{{ titleText }}</div>
      <div  class="userNameText" >
        <!-- {{ userNickname }}，您好
        <span class="logout-btn" @click="handleLogout">[退出]</span> -->
        <div v-if="hasToken">
          <el-dropdown  @command="(command) => handleTableCommand(command)">
      <span class="el-dropdown-link">
        {{ userInfo.name ?? '用户' }}，您好<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="improveUser">完善用户信息</el-dropdown-item>
        <el-dropdown-item command="loginout">退出登录</el-dropdown-item>

      </el-dropdown-menu>
    </el-dropdown>
        </div>

      </div>
    </div>

    <!-- 完善用户信息弹窗 -->
    <PerfectInfoDialog
      :visible.sync="showPerfectInfoDialog"
      :nickname="nickname"
      :avatar="avatar"
      @submit="handlePerfectInfoSubmit"
      @close="handlePerfectInfoClose"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PerfectInfoDialog from './PerfectInfoDialog'
import { userDetail } from '@/api'
export default {
  name: 'BgManageTopbar',
  components: {
    PerfectInfoDialog
  },
  props: {
    // 是否是注册页面（显示"去登录"，否则显示"官网首页"）
    isRegister: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      titleText: '',
      hasToken: false,
      showPerfectInfoDialog: false,
      nickname: '',
      avatar: ''
    }
  },
  computed: {
    ...mapState('userAbout', ['userInfo', 'isLogin']),
  },
  mounted(){
    this.getCheckDate()
    // this.getDate()
    // 从 sessionStorage 获取 token 存入 data
    this.hasToken = !!sessionStorage.getItem('token')
  },
  methods: {
       getCheckDate(){
      this.$API.getCurrGames().then(res => {
        console.log("res=========", res);
         const nowYear = new Date().getFullYear()
         this.titleText = `${res.data.name}"新动能科技成果"申报系统(${nowYear})`
      })
    },
    handleTableCommand(type){
      switch (type) {
        case 'loginout':
          this.handleLogout()
          break;
        case 'improveUser':
          this.openPerfectInfoDialog()
          break;
      }
    },
    openPerfectInfoDialog() {
      // 从 userInfo 中获取当前用户信息
      this.nickname = this.userInfo.nickname || this.userInfo.name || ''
      this.avatar = this.userInfo.head_img_url || ''
      this.showPerfectInfoDialog = true
    },
    handlePerfectInfoSubmit(data) {
      console.log('提交用户信息:', data)
      this.$API.goPerfectInfo({
        head_img_url: data.avatar,
        nickname: data.nickname,
      }).then(res => {
        // 调用获取用户信息接口
        userDetail().then(result => {
          if (result.code === 200) {
            this.$store.commit('userAbout/USERLOGIN', result.data)
          }
        })
      })
    },
    handlePerfectInfoClose() {
      console.log('关闭完善信息弹窗')
    },
    goLogin(){
      this.$router.push({ path: "/Login" });
    },
    handleLogout(){
      this.$store.dispatch('userAbout/userLogout').then(() => {
        this.$message.success('退出成功')
        this.$router.push('/Home')
      })
    },
    getDate(){
      const nowYear = new Date().getFullYear()
      // 从2024年开始，每两年一届
      const session = Math.floor((nowYear - 2024) / 2) + 1
      this.titleText = `第${this.convertToChinese(session)}届"新动能科技成果"申报系统(${nowYear})`
    },
  // 数字转中文（支持1-30）
  convertToChinese(num) {
    const chineseNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
    if (num <= 10) {
      return chineseNum[num]
    }
    if (num < 20) {
      return '十' + (num % 10 === 0 ? '' : chineseNum[num % 10])
    }
    if (num < 30) {
      return '二十' + (num % 10 === 0 ? '' : chineseNum[num % 10])
    }
    if (num === 30) {
      return '三十'
    }
    return num
  },
    goHome() {
      this.$router.push({ path: "/Home" });
    }
  },

}
</script>

<style scoped lang="scss">
.el-dropdown-link{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #FFFFFF;
cursor: pointer;
}
.goLogin{
  width: 22px;
  height: 22px;
  margin-right: 5px;
}
.goRegister{
  margin-left: 50px;
  display: flex;
}
.leftIconDiv{
  display: flex;
  cursor: pointer;
}
.userNameText{
  min-width: 100px;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #FFFFFF;

.logout-btn {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  
  &:hover {
    opacity: 0.8;
  }
}
}
.titleText{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 20px;
color: #FFFFFF;

}
.goHomeText{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #FFFFFF;

}
.flex{
  display: flex;
  align-items: center;
}
.goHomeIcon{
  width: 19px;
  height: 19px;
  margin-right: 5px;
}
.bgManageTopbar {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('../../../assets/sTop.png') no-repeat center center;
  background-size: 100% 100%;
}
.topbarContent{
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  width: 1200px;
}

</style>
